import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { apiEndPoints } from '../../../api/apiEndPoint';
import { ReportsService } from '../../../Services/reports.service';
import { ToastrService } from 'ngx-toastr';
import { GoogleMapsModule } from '@angular/google-maps';
import { MapService } from '../../../Services/map.service';

@Component({
  selector: 'app-dumpster-location',
  standalone: true,
  imports: [CommonModule, GoogleMapsModule],
  templateUrl: './dumpster-location.component.html',
  styleUrl: './dumpster-location.component.css',
})
export class DumpsterLocationComponent implements OnInit {
  userTypeList: any;
  dumpsterList: any;
  center: google.maps.LatLngLiteral = { lat: 12.9716, lng: 77.5946 };
  zoom = 10;
  selectedDumpsterId: any;
  dumpsterLocation: any;
  markers: any;

  constructor(
    private reportService: ReportsService,
    private toastr: ToastrService,
    private mapService: MapService
  ) {}

  ngOnInit(): void {
    this.getDumpsterList();
  }

  // ------------------ Dumpster List Api ------------------ //

  getDumpsterList() {
    this.reportService
      .getAllUserSummary(apiEndPoints.summaryUserList)
      .subscribe({
        next: (response: any) => {
          let allowedTypes = ['3'];
          this.dumpsterList = response.body?.details.filter((data: any) =>
            allowedTypes.includes(data.userType)
          );
        },
        error: (error) => {
          this.toastr.error(
            'An unexpected error occurred. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
        },
      });
  }

  onDumpsterChange(event: Event) {
    const selectedDumpsterId = (event.target as HTMLSelectElement).value;
    this.selectedDumpsterId = selectedDumpsterId;
    this.getDumpsterLocation();
  }

  // ------------------ Get Dumpster Location API ------------------ //

  getDumpsterLocation() {
    this.mapService
      .getDumpsterLocation(
        apiEndPoints.dumpsterLocation,
        this.selectedDumpsterId
      )
      .subscribe({
        next: (response: any) => {
          if (response.isSuccess) {
            const containerDetails =
              response.body.details.currentContainerDetails;

            this.markers = containerDetails
              .filter(
                (item: any) =>
                  item.latitude !== '0.0' && item.longitude !== '0.0'
              )
              .map((item: any) => ({
                position: {
                  lat: parseFloat(item.latitude),
                  lng: parseFloat(item.longitude),
                },
                title: `Order ID: ${item.orderId}`,
                icon: {
                  url: 'assets/Images/map_marker_dumpyard.png',
                  scaledSize: new google.maps.Size(70, 50),
                },
              }));

            if (this.markers.length > 0) {
              this.center = this.markers[0].position;

              let startZoom = 5; 
              const endZoom = 14; 
              const stepTime = 50; 
              const mapZoomInterval = setInterval(() => {
                if (startZoom < endZoom) {
                  startZoom++;
                  this.zoom = startZoom;
                } else {
                  clearInterval(mapZoomInterval);
                }
              }, stepTime);
            }
            console.log(this.markers);
          }
        },
      });
  }

  onMarkerClick(marker: any) {
    console.log('Clicked marker:', marker.title);
  }
}
